<template>
    <div class="col backgroundForm">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-success" role="alert" align="center">
                <h4 class="alert-heading">Autorizacion de impresion Matricula</h4>
                <p>Indique su {{ searchTypeR.toLowerCase() }}</p>
                <hr>
            </div>
            <form @submit.prevent="searchBoat">

                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="btn btn-success active" @click="mViewSearch">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"   value="enrollment" checked> Nombre
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2"  value="name" > Matricula
                    </label>
                </div>

                <div class="form-group"> 
                    <label for="nombreEmbarcacion"></label>
                    <input type="text" class="form-control" id="enrollment_boat_r" :placeholder="searchTypeR" autocomplete="off" v-model="data_boat">
                    <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeR.toLowerCase() }}</small>
                </div>
                <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" >Buscar</button>
            </form>
        </div>
        <br><br>
        <transition name="fade" mode="out-in">
            <div class="col-12 col-md-10 offset-md-1 table-responsive" v-if="dtsBoats.length > 0">
                <table class="table table-striped">
                    <thead class="thead-dark">
                        <tr>
                            <th scoped="col">#</th>
                            <th scoped="col">Nombre</th>
                            <th scoped="col">Matricula</th>
                            <th scoped="col">Tipo</th>
                            <th scoped="col">Capitania</th>
                            <th scoped="col">Detalle</th>
                            <th scoped="col">Orden Impresion</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(db, index) in dtsBoats" :key="db.id">
                            <td>{{ (index+1) }}</td>
                            <td>{{ db.name_boat }}</td>
                            <td>{{ db.enrollment ? db.enrollment : db.enrollment_old }}</td>
                            <td>{{ db.detail_boat }}</td>
                            <td>{{ db.port }}</td>
                            <td><button class="btn btn-warning" @click="viewDtsModal(db)"><font-awesome-icon icon="eye" /></button></td>
                            <td align="center"><button class="btn btn-success" @click="mGenerateCode(db)"><font-awesome-icon icon="check" /></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </transition>
        <modal-ship :id-modal-data="idModalData" :ship="boatSelect" :name-ship="boatSelect.nameShip"></modal-ship>
        <modal-print :title="tModalPrint" :id-modal-print="idModalPrint" :content-print="contentPrint" :is-xl="printXl"></modal-print>
        <modal-loading :id-modal="idModalLoad" :title="titleLoad" :status-send="sendRequest"></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

import modalShip from './ViewDtsShip';
import modalLoading from '../modal/modalLoading';
import modalPrint from '../modal/modalPrint';

export default {
    name:'order-print',
    data(){
        return{
            optionSearchR:'name',
            data_boat:null,
            dtsBoats:[],
            boatSelect:{
                nameShip:null,
                enrollment:null,
                enrollment_old:null,
                type:null,
                propulsion:null,
                trn:null,
                trb:null,
                port:null
            },
            idModalData:'dtsGralShip',
            idBoatSelect:0,
            contentPrint:'',
            idModalPrint:'printDtsAutorizacion',
            tModalPrint:'Autorizacion Impresion',
            printXl:true,
            idModalLoad:'loadingCharge',
            titleLoad:'Solicitando',
            sendRequest:true
        }
    },
    methods:{
        async searchBoat(){
            this.dtsBoats=[];
            try {
                // solo se debe listar las las naves que esten en estado revisado
                if(this.data_boat != null){
                    let rn=await axios.get(`searchShipOrderPrint/${this.optionSearchR}/${this.data_boat}?api_token=${Vue.auth.getToken()}`);
                    if(rn.data.length > 0){
                        this.dtsBoats=rn.data;
                    }else{
                        toastr.info('No existen coincidencias', 'Advertencia');
                    }                    
                }else{
                    toastr.warning(`Indique ${this.searchTypeR}`, 'Advertencia');
                }
            } catch (error) {
                console.log(error);
            }            
        },
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            this.optionSearchR=radioV;
        },
        viewDtsModal(e){
            // console.log(e);
            this.boatSelect.nameShip=e.name_boat;
            this.boatSelect.enrollment=e.enrollment;
            this.boatSelect.enrollment_old=e.enrollment_old;
            this.boatSelect.type=e.detail_boat;
            this.boatSelect.propulsion=e.detail_propulsion
            this.boatSelect.trn=e.trn;
            this.boatSelect.trb=e.trb;
            this.boatSelect.port=e.port;
            // console.log(this.boatSelect);
            setTimeout(()=>{
                this.mShowModalRec(this.idModalData);
            },1000);            
        },
        mGenerateCode(e){
            this.idBoatSelect=0;
            let message = {
                title: 'Nueva Orden de Impresion',
                body: `Desea Generar un nuevo codigo de impresion? y anular todos los anteriores`
            };
            // console.log(`el id del bote seleccionado es ${e}`);
            this.idBoatSelect=e.id_boat;
            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            })

            npr.then(async (msg)=>{
                
                if(msg){
                    // activamos el modal de envio una vez finalizado abrir el otro modal para la impresion
                    this.mShowModalRec(this.idModalLoad);
                    try {
                        let id_aux={
                            id_s:this.idBoatSelect
                        }
                        let nc=await axios.post(`generatePrint?api_token=${Vue.auth.getToken()}`, qs.stringify(id_aux));
                        let rs=nc.data;
                        if(rs[0].status){                            
                            toastr.success(rs[0].respuesta, 'Exito');
                            setTimeout(()=>{
                                this.mCloseModalRec(this.idModalLoad);
                                this.mGeneraPrint(e,rs);
                            },2000)                            
                            // llegamos para hacer la impresion del recibo de autorizacion
                            
                        }else{
                            toastr.error(rs[0].respuesta, 'Error');
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }else{
                    console.log('se ha rechazado la generacion de codigo');
                }
            })
        },
        mGeneraPrint(s,a){
            // aqui generamos toda la tabla a enviar para imprimir
            let enroll='SIN REGISTRO';
            if(s.enrollment !== null ){
                enroll=s.enrollment;
            }else{
                enroll=s.enrollment_old;
            }
            let bodyPrint=`<table class="table" width="100%">                
                    <tr>
                        <td align="center"><b>Nombre Embarcacion</b></td>
                        <td align="center"><b>Matricula</b></td>
                    </tr>
                    <tr>
                        <td align="center">${s.name_boat}</td>
                        <td align="center">${enroll}</td>
                    </tr>
                    <tr>
                        <td align="center"><b>TRB/TRN</b></td>
                        <td align="center"><b>Tipo</b></td>
                    </tr>
                    <tr>
                        <td align="center">${s.trb}/${s.trn}</td>
                        <td align="center">${s.detail_boat}</td>
                    </tr>
                    <tr>
                        <td align="center"><b>Codigo de Autorizacion</b></td>
                        <td align="center"><b>Fecha de Vencimiento</b></td>
                    </tr>
                    <tr>
                        <td align="center">${a[0].codigo}</td>
                        <td align="center">${a[0].vencimiento}</td>
                    </tr>
            </table>`;
            this.contentPrint=bodyPrint;
            this.mShowModalRec(this.idModalPrint);
        },
        mShowModalRec(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalRec(idM){
            $('#'+idM).modal('hide');
        }
    },
    computed:{
        searchTypeR(){
            
            switch(this.optionSearchR){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
    },
    components:{
        'modal-loading':modalLoading,
        'modal-ship':modalShip,
        'modal-print':modalPrint
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/matriculacion/OrderPrintEnrollment.vue